export default __webpack_public_path__ + "static/media/power7.99527e97.svg";